// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-authenticator .v-window__container .v-window-item>div{height:auto!important}", ""]);
// Exports
module.exports = exports;
